export default () => ({
	onSubmit() {
		document.cookie = 'selectedPlan=; Max-Age=0; path=/;';
	}
});